module.exports = __webpack_public_path__ + "static/media/masonry_3.fd0705e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/textures/masonry_3.jpg
// module id = 1132
// module chunks = 0